/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import type { FormProps } from 'redux-form';
import { Tab, Tabs } from 'material-ui/Tabs';
import RaisedButton from 'material-ui/RaisedButton';

import Well from '../../components/Well';
import type { TutorApproval_tutor } from './__generated__/TutorApproval_tutor.graphql';

import TutorDocumentModal from './components/TutorDocumentModal';
import TutorDocuments from './components/approval/TutorDocuments';
import TutorSubjectGrades from './components/approval/TutorSubjectGrades';

import Loader from '../../components/Loader';
import ApproveTutorMutation from './mutations/ApproveTutorMutation';
import RejectTutorMutation from './mutations/RejectTutorMutation';
import enahncer from '../../enhancer';

type Props = {
  tutor: TutorApproval_tutor,
} & FormProps;

type State = {
  loading: boolean,
  documentModal: {
    open: boolean,
    document?: {
      uri: string,
      description: string,
    },
  },
};

const styles = {
  button: {
    margin: 5,
  },
};

class TutorApproval extends Component<Props, State> {
  state = {
    loading: false,
    documentModal: {
      open: false,
    },
  };

  componentDidMount() {
    const { tutor: { approvals }, initialize } = this.props;

    const data = approvals.reduce((acc, approval) => {
      acc[approval.subjectGradeId] = approval.approved;
      return acc;
    }, {});

    initialize(data);
  }

  onSubmit = async data => {
    const { tutor, history } = this.props;
    const approvedSubjectGradeIds = Object.entries(data)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, value]) => value)
      // eslint-disable-next-line no-unused-vars
      .map(([key, value]) => key);

    try {
      await ApproveTutorMutation({
        input: {
          tutorId: tutor.id,
          approvedSubjectGradeIds,
        },
      });

      history.push(`/admin/tutor/${tutor.id}`);
    } catch (ex) {
      // eslint-disable-next-line no-alert
      alert(ex);
    }
  };

  handleReject = async () => {
    const { tutor, history } = this.props;
    this.setState({ loading: true });

    try {
      await RejectTutorMutation({
        input: { tutorId: tutor.id },
      });

      history.push('/admin/tutor/');
    } catch (ex) {
      this.setState({ loading: false });
      // eslint-disable-next-line no-alert
      alert(ex);
    }
  };

  handleDocumentClick = document => {
    this.setState({
      documentModal: {
        open: true,
        document,
      },
    });
  };

  handleDocumentClose = () => {
    this.setState({
      documentModal: {
        open: false,
      },
    });
  };

  render() {
    const { tutor, master, submitting, handleSubmit } = this.props;
    const { documentModal, loading } = this.state;

    const Approval = () => (
      <div>
        <TutorDocumentModal
          handleClose={this.handleDocumentClose}
          {...documentModal}
        />
        <TutorSubjectGrades tutor={tutor} master={master} />
        {(submitting || loading) && <Loader />}
        <RaisedButton
          label="Approve"
          fullWidth
          disabled={submitting || loading}
          primary
          style={styles.button}
          onClick={handleSubmit(this.onSubmit)}
        />
        <RaisedButton
          label="Reject"
          fullWidth
          disabled={submitting || loading}
          secondary
          style={styles.button}
          onClick={this.handleReject}
        />
      </div>
    );

    return (
      <Well>
        <Tabs>
          <Tab label="Approval" value="approval">
            <Approval />
          </Tab>
          <Tab label="Documents" value="documents">
            <TutorDocuments
              tutor={tutor}
              handleDocumentClick={this.handleDocumentClick}
            />
          </Tab>
        </Tabs>
      </Well>
    );
  }
}

const query = graphql`
  query TutorApprovalAdminQuery($nodeId: ID!) {
    tutor: node(id: $nodeId) {
      ...TutorApproval_tutor
    }
    master {
      ...TutorSubjectGrades_master
    }
  }
`;

export default enahncer(TutorApproval, {
  form: {
    form: 'tutorApproval',
  },
  relay: {
    query,
    create: () =>
      createFragmentContainer(TutorApproval, {
        tutor: graphql`
          fragment TutorApproval_tutor on Tutor {
            id
            ...TutorDocuments_tutor
            ...TutorSubjectGrades_tutor
            approvals {
              approved
              subjectGradeId
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/TutorApproval.js